import React, { useState, useEffect, useContext } from "react";
import PopoverInput from "./inner/popoverInput.jsx";
import { IsMobileContext } from "../context/contexts.jsx";
import { signpostIcon } from "./inner/fieldIcons.jsx";

// "Santorini & Milos" should be found by "santorini and", "milos", "Mílos"...
const normalise = (text) => (text ?? "")
    .normalize("NFD").replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/\s+/g, " ")
    .trim();

// Type-ahead over the island hops ([{ group, items: [{ name, url }] }]). Choosing one closes the
// panel; the form's button then goes to that hop's page (island hopping has no booking).
const IslandHopPicker = ({ groups, selected, onSelect, error }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [filterText, setFilterText] = useState("");
    const isMobile = useContext(IsMobileContext);

    // The field shows the chosen hop again once the panel closes, not leftover typed text.
    useEffect(() => {
        if (!isOpen) {
            setFilterText("");
        }
    }, [isOpen]);

    const query = normalise(filterText);
    const matches = groups
        .map((g) => ({
            group: g.group,
            items: query
                ? g.items.filter((hop) => normalise(hop.name).includes(query) || normalise(g.group).includes(query))
                : g.items,
        }))
        .filter((g) => g.items.length > 0);

    const choose = (hop) => {
        onSelect(hop);
        setIsOpen(false);
    };

    // Mobile types into a box in the full-screen panel (the field itself is read-only there).
    const header = isMobile ? (
        <input type="text" autoComplete="off" value={filterText} onChange={(e) => setFilterText(e.target.value)}
            className="oly-form-input" placeholder="Search island hops" aria-label="Search island hops" />
    ) : null;

    return <PopoverInput label="Choose Your Island Hop" anchor="field" error={error} header={header}
        icon={signpostIcon} inputText={selected ? selected.name : "Select A Hop"} isLoading={false}
        onTextUpdate={setFilterText} filterText={filterText} isOpen={isOpen} setIsOpen={setIsOpen}>
        <div role="listbox" aria-label="Island hops" className="pr-2">
            {matches.length == 0 && (
                <div className="text-ink-soft text-sm p-3 text-center">No island hops match &ldquo;{filterText}&rdquo;.</div>
            )}
            {matches.map((g) => (
                <div key={g.group} role="group" aria-label={g.group}>
                    <div className="px-2 pt-3 pb-1 text-xs font-semibold uppercase tracking-wide text-navy-700">{g.group}</div>
                    {g.items.map((hop) => {
                        const isSelected = selected?.url == hop.url;
                        return (
                            <button key={hop.url} type="button" role="option" aria-selected={isSelected} onClick={() => choose(hop)}
                                className={"block w-full text-left rounded-[0.5rem] px-2 py-2 text-sm cursor-pointer focus-visible:outline-2 focus-visible:outline-sky-600 " +
                                    (isSelected ? "bg-sky-50 font-semibold text-navy-700" : "text-ink hover:bg-sky-50")}>
                                {hop.name}
                            </button>
                        );
                    })}
                </div>
            ))}
        </div>
    </PopoverInput>;
};
export default IslandHopPicker;
